import {
  checkIdentification,
  checkResetPwdToken,
  login,
  register,
  resendVerifyEmail,
  sendForgetPasswordLink,
  sendResetPasswordLink,
  updateUser,
  getUserInfo,
  getUserRole,
} from '@/api/user';
import { snackbar } from '@/plugins/snackbar';
import { SNACKBAR_TYPES } from '@/utils/constants';

import {
  CHECK_IDENTIFICATION,
  CHECK_RESET_PASSWORD_TOKEN,
  CHECKING_RESET_PASSWORD_TOKEN,
  RESEND_VERIFY_EMAIL,
  RESENDING_VERIFY_EMAIL,
  SEND_FORGET_PASSWORD_LINK,
  SEND_RESET_PASSWORD_LINK,
  SENDING_FORGET_PASSWORD_LINK,
  SENDING_RESET_PASSWORD_LINK,
  SET_IDENTIFICATION,
  SET_USER_REGISTER_FORM_DONE,
  SET_USER_REGISTER_FORM,
  SET_USER_ROLE,
  USER_ROLE,
  UPDATE_USER,
  UPDATING_USER,
  USER_LOGGING,
  USER_LOGIN_DONE,
  USER_LOGIN,
  USER_LOGOUT,
  USER_LOGOUT_DONE,
  USER_REGISTER,
  USER_REGISTERING,
  GET_USER_INFO,
} from './constants';

export default {
  async [CHECK_IDENTIFICATION](_, identification) {
    try {
      const res = await checkIdentification(identification);
      return Promise.resolve(res);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async [CHECK_RESET_PASSWORD_TOKEN]({ commit }, token) {
    commit(CHECKING_RESET_PASSWORD_TOKEN, true);
    try {
      const { token: res } = await checkResetPwdToken(token);
      localStorage.setItem('_t', res);
      commit(CHECKING_RESET_PASSWORD_TOKEN, false);
      return Promise.resolve();
    } catch (error) {
      commit(CHECKING_RESET_PASSWORD_TOKEN, false);
      return Promise.reject(error);
    }
  },
  async [RESEND_VERIFY_EMAIL]({ commit }, email) {
    commit(RESENDING_VERIFY_EMAIL, true);
    try {
      await resendVerifyEmail(email);
      commit(RESENDING_VERIFY_EMAIL, false);
      return Promise.resolve();
    } catch (error) {
      commit(RESENDING_VERIFY_EMAIL, false);
      return Promise.reject(error);
    }
  },
  async [SEND_FORGET_PASSWORD_LINK]({ commit }, email) {
    commit(SENDING_FORGET_PASSWORD_LINK, true);
    try {
      await sendForgetPasswordLink(email);
      commit(SENDING_FORGET_PASSWORD_LINK, false);
      return Promise.resolve();
    } catch (error) {
      commit(SENDING_FORGET_PASSWORD_LINK, false);
      return Promise.reject(error);
    }
  },
  async [SEND_RESET_PASSWORD_LINK]({ commit }, form) {
    commit(SENDING_RESET_PASSWORD_LINK, true);
    try {
      await sendResetPasswordLink(form);
      commit(SENDING_RESET_PASSWORD_LINK, false);
      return Promise.resolve();
    } catch (error) {
      commit(SENDING_RESET_PASSWORD_LINK, false);
      return Promise.reject(error);
    }
  },
  async [UPDATE_USER]({ commit }, data) {
    commit(UPDATING_USER, true);
    try {
      await updateUser(data);
      commit(UPDATING_USER, false);
      return Promise.resolve();
    } catch (error) {
      commit(UPDATING_USER, false);
      return Promise.reject(error);
    }
  },
  async [USER_REGISTER]({ commit }, form) {
    commit(USER_REGISTERING, true);
    try {
      await register(form);
      commit(USER_REGISTERING, false);
      return Promise.resolve();
    } catch (error) {
      const { message } = error;
      snackbar({ type: SNACKBAR_TYPES.ERROR, msg: `註冊失敗。(錯誤：${message})` });
      commit(USER_REGISTERING, false);
      return Promise.reject(error);
    }
  },
  async [USER_LOGIN]({ commit }, form) {
    commit(USER_LOGGING, true);
    try {
      const { team_identification: identification, token } = await login(form);
      localStorage.setItem('_i', identification);
      localStorage.setItem('_t', token);
      commit(SET_IDENTIFICATION, identification);
      commit(USER_LOGIN_DONE, token);
      commit(USER_LOGGING, false);
      return Promise.resolve();
    } catch (error) {
      commit(USER_LOGIN_DONE, null);
      commit(USER_LOGGING, false);
      return Promise.reject(error);
    }
  },
  [SET_USER_REGISTER_FORM]({ commit }, payload) {
    commit(SET_USER_REGISTER_FORM_DONE, payload);
  },
  [USER_LOGOUT]({ commit }) {
    localStorage.removeItem('_i');
    localStorage.removeItem('_t');
    commit(USER_LOGOUT_DONE);
  },
  async [GET_USER_INFO]() {
    const userInfo = await getUserInfo();
    return userInfo;
  },
  async [SET_USER_ROLE]({ commit }) {
    const { data: role } = await getUserRole();
    commit(USER_ROLE, role);
  },
};
